module.exports = __webpack_public_path__ + "img/SES_210425255.d7699c74.jpg";